import { render, staticRenderFns } from "./PrivacyAppDelete.vue?vue&type=template&id=5da55984&scoped=true"
import script from "./PrivacyAppDelete.vue?vue&type=script&lang=js"
export * from "./PrivacyAppDelete.vue?vue&type=script&lang=js"
import style0 from "./PrivacyAppDelete.vue?vue&type=style&index=0&id=5da55984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da55984",
  null
  
)

export default component.exports